import { useSlots as _useSlots, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { getVatClasses } from '@/api/utils'
import { computedAsync } from '@vueuse/core'
import { type VSelect } from 'vuetify/components'

type Slots = VSelect['$slots']


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'VatSelect'
},
  __name: 'VatSelect',
  setup(__props) {



const slots = _useSlots()

const vatClasses = computedAsync(() => getVatClasses(), [], { flush: 'pre' })

return (_ctx: any,_cache: any) => {
  const _component_VSelect = _resolveComponent("VSelect")!

  return (_openBlock(), _createBlock(_component_VSelect, {
    label: _ctx.$t('form.label.vat_percentage'),
    items: _unref(vatClasses),
    "item-title": "name",
    "item-value": "percentage"
  }, _createSlots({ _: 2 }, [
    _renderList(Object.keys(slots), (slot, index) => {
      return {
        name: slot,
        fn: _withCtx(() => [
          _renderSlot(_ctx.$slots, slot)
        ])
      }
    })
  ]), 1032, ["label", "items"]))
}
}

})